import { buildFamsMenuMessages } from 'config/fams-menu';

export default {
  'menu.login': '登录',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.logout': '退出登录',
  ...buildFamsMenuMessages('zh-CN'),
};
